import {Values} from "@wix/devzai-utils-common";

export const DoppeAutoEventType = {
    UpcomingAndOld: 'Latest',
    Upcoming: 'Upcoming',
    Old: 'Old',
} as const;

export type DoppeAutoEventType = Values<typeof DoppeAutoEventType>;